/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Unit_IdsInputs */

const cs_property_registry_unit_ids = /** @type {(inputs: Property_Registry_Unit_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID jednotek`)
};

const en_property_registry_unit_ids = /** @type {(inputs: Property_Registry_Unit_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit IDs`)
};

/**
* | output |
* | --- |
* | "Unit IDs" |
*
* @param {Property_Registry_Unit_IdsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_unit_ids = /** @type {((inputs?: Property_Registry_Unit_IdsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Unit_IdsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_unit_ids(inputs)
	return cs_property_registry_unit_ids(inputs)
});